import styled from 'styled-components'

export const LogoWrapper = styled.div`
	border-radius: 6px;
	overflow: hidden;
`
